<mat-icon *ngIf="direction === 'inbound'" matTooltip="Incoming">
  call_received
</mat-icon>
<mat-icon *ngIf="direction === 'outbound'" matTooltip="Outgoing">
  call_made
</mat-icon>
